'use client';

import FaIcon from '@/components/icon/FaIcon/FaIcon';
import utilsStyles from '@/styles/modules/utils.module.scss';
import { goMainOneTimeAuth } from '@/utils/functions';
import { faChevronRight } from '@fortawesome/free-solid-svg-icons';
import styles from './ContactHeaderSideNode.module.scss';

function ContactHeaderSideNode() {
  const handleClick = (e: React.MouseEvent) => {
    e.preventDefault();
    goMainOneTimeAuth({
      redirectPath: '/account/contact-history',
    });
  };
  return (
    <a
      href='#'
      className={`${utilsStyles.textSmall} ${styles.linkListItem}`}
      onClick={(e) => {
        handleClick(e);
      }}
    >
      <div className={styles.linkListItem}>
        返信一覧 &nbsp;
        <FaIcon icon={faChevronRight} size='sm'></FaIcon>
      </div>
    </a>
  );
}

export default ContactHeaderSideNode;
